import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';

import store from '@/store';
import {
  getIdentityDocuments,
  IdentityDocument,
} from '@/api/identityDocuments';
import { ErrorAlertModule } from '@/store/modules/errors';
import { errorHandler } from "@/utils/common";

export interface IIdentityDocumentsState {
  list: IdentityDocument[];
}

@Module({ dynamic: true, store, name: 'identityDocuments' })
class IdentityDocuments extends VuexModule implements IIdentityDocumentsState {
  list: IdentityDocument[] = [];
  loaded = false;
  loading = false;

  @Mutation
  loadIdentityDocumentsAllPending() {
    this.list = [];
    this.loading = true;
    this.loaded = false;
  }

  @Mutation
  loadIdentityDocumentsAllFulfilled(data: IdentityDocument[]) {
    this.loading = false;
    this.loaded = true;
    this.list = data;
  }

  @Mutation
  loadIdentityDocumentsAllRejected() {
    this.loading = false;
    this.loaded = false;
  }

  @Action
  async loadIdentityDocumentsAll() {
    ErrorAlertModule.setErrorAlert('');
    this.loadIdentityDocumentsAllPending();

    try {
      const data = await getIdentityDocuments();
      this.loadIdentityDocumentsAllFulfilled(data);
    } catch (error) {
      this.loadIdentityDocumentsAllRejected();
      errorHandler(error)
    }
  }
}

export const IdentityDocumentsModule = getModule(IdentityDocuments);
